export const REGEX = {
  ROULETTE_PROMO_CODE: /^RLT[A-Z0-9]{4}$/,
};
